.connection-start {
  margin-top: 0.5em;

  .suggestion-container {
    margin: 1em 0;
  }
}
